<script setup>
import { ref, onMounted } from "vue"
import { useRoute } from "vue-router"
import { Thumbs } from "swiper"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import SwiperCore, { Pagination, Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/vue"
import "swiper/swiper-bundle.css"

SwiperCore.use([Pagination, Navigation])

import * as persianTools from "@persian-tools/persian-tools"
import PersianDate from "persian-date"

import store from "../../state/store"

SwiperCore.use([Pagination, Navigation])

const title = "جزئیات محصول"
const items = [
  {
    text: "محصولات",
    href: "/dashboard/products",
  },
  {
    text: "جزئیات محصول",
    active: true,
  },
]

const route = useRoute()
const id = route.params.id

const productDetails = ref([])
const stars = ref([])
const productGallery = ref([])

onMounted(async () => {
  const { data } = await store.dispatch("getProduct", id)
  productDetails.value = {
    ...data.data,
  }

  productGallery.value = Object.values(data.data.product_gallery)

  const averageRating = productDetails.value.average_rating
  const fullStars = Math.floor(averageRating)
  const halfStar = averageRating - fullStars >= 0.5
  const emptyStars = 5 - (fullStars + (halfStar ? 1 : 0))

  for (let i = 0; i < fullStars; i++) {
    stars.value.push("ri-star-fill")
  }

  if (halfStar) {
    stars.value.push("ri-star-half-fill")
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.value.push("ri-star-line")
  }
})

const thumbsSwiper = ref(null)

const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper
}

const toPersianDateTime = (date) => {
  const [datePart, timePart] = date.split(" ")
  const [year, month, day] = datePart.split("-")
  const [hour, minute] = timePart.split(":")
  const gregorianDate = new Date(year, month - 1, day, hour, minute)
  const persianDate = new PersianDate(gregorianDate)
  return persianDate.format("YYYY/MM/DD HH:mm")
}

const extractTextFromFirstParagraph = (html) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, "text/html")
  const firstParagraph = doc.querySelector("p")
  return firstParagraph ? firstParagraph.textContent : ""
}

const getVariant = (star) => {
  if (star >= 3) {
    return "success"
  } else if (star == 2) {
    return "warning"
  } else if (star == 1) {
    return "danger"
  } else {
    return ""
  }
}

const getVariantClass = (variant) => {
  if (variant === "success") {
    return "bg-soft-success"
  } else if (variant === "warning") {
    return "bg-soft-warning"
  } else if (variant === "danger") {
    return "bg-soft-danger"
  } else {
    return ""
  }
}

const formattedPrices = (value) => {
  return new Intl.NumberFormat("fa-IR").format(value)
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <b-row class="gx-lg-5">
              <b-col xl="4" md="8" class="mx-auto">
                <div
                  class="product-img-slider sticky-side-div"
                  v-if="productGallery.length > 0"
                >
                  <swiper
                    :modules="[Thumbs]"
                    class="product-thumbnail-slider p-2 rounded bg-light"
                    :navigation="{
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    }"
                    :thumbs="{
                      swiper: thumbsSwiper,
                    }"
                  >
                    <swiper-slide
                      v-for="(gallery, index) of productGallery"
                      :key="index"
                    >
                      <img
                        :src="gallery.original_url"
                        :alt="gallery.name"
                        class="img-fluid d-block"
                      />
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-button-next bg-white shadow"></div>
                  <div class="swiper-button-prev bg-white shadow"></div>
                  <swiper
                    :modules="[Thumbs]"
                    class="product-nav-slider mt-2"
                    :loop="false"
                    :spaceBetween="10"
                    :slidesPerView="4"
                    :freeMode="true"
                    watch-slides-progress
                    @swiper="setThumbsSwiper"
                  >
                    <swiper-slide
                      v-for="(gallery, index) of productGallery"
                      :key="index"
                    >
                      <div class="nav-slide-item">
                        <img
                          :src="gallery.original_url"
                          :alt="gallery.name"
                          class="img-fluid d-block"
                        />
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </b-col>

              <b-col xl="8">
                <div class="mt-xl-0 mt-5">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <h4>{{ productDetails.product_name }}</h4>
                      <div class="hstack gap-3 flex-wrap">
                        <div class="text-muted">
                          توسط :
                          <span class="text-body fw-medium">{{
                            productDetails.created_by
                          }}</span>
                        </div>
                        <div class="vr"></div>
                        <div class="text-muted">
                          تاریخ ایجاد :
                          <span class="text-body fw-medium">{{
                            productDetails.dateTime
                              ? toPersianDateTime(productDetails.dateTime)
                              : ""
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flex-shrink-0">
                      <div>
                        <router-link
                          :to="{
                            name: 'product.products',
                          }"
                          class="btn btn-light me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="لیست محصولات"
                        >
                          <i class="ri-arrow-go-forward-fill align-bottom"></i>
                        </router-link>
                        <router-link
                          :to="{
                            name: 'product.edit',
                            params: { id: id },
                          }"
                          class="btn btn-light"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="ویرایش"
                        >
                          <i class="ri-pencil-fill align-bottom"></i>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <b-row class="mt-4">
                    <b-col sm="12" md="5">
                      <div class="p-2 border border-dashed rounded">
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                            <div
                              class="avatar-title rounded bg-transparent text-success fs-24"
                            >
                              <i class="ri-money-dollar-circle-fill"></i>
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <p class="text-muted mb-1">قیمت :</p>
                            <div v-if="productDetails.discount_price">
                              <h5 class="mb-0">
                                <span
                                  class="text-decoration-line-through text-muted"
                                >
                                  {{
                                    formattedPrices(
                                      productDetails.product_price
                                    )
                                  }}
                                </span>
                                {{
                                  formattedPrices(productDetails.discount_price)
                                }}
                              </h5>
                            </div>
                            <h5 class="mb-0" v-else>
                              {{
                                formattedPrices(productDetails.product_price)
                              }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <b-col sm="6" md="4">
                      <div class="p-2 border border-dashed rounded">
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                            <div
                              class="avatar-title rounded bg-transparent text-success fs-24"
                            >
                              <i class="ri-file-copy-2-fill"></i>
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <p class="text-muted mb-1">تعداد سفارشات :</p>
                            <h5 class="mb-0">
                              {{
                                productDetails.delivered_order_count
                                  ? persianTools.digitsEnToFa(
                                      productDetails.delivered_order_count
                                    )
                                  : persianTools.digitsEnToFa(0)
                              }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </b-col>

                    <b-col sm="6" md="3">
                      <div class="p-2 border border-dashed rounded">
                        <div class="d-flex align-items-center">
                          <div class="avatar-sm me-2">
                            <div
                              class="avatar-title rounded bg-transparent text-success fs-24"
                            >
                              <i class="ri-stack-fill"></i>
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <p class="text-muted mb-1">موجودی:</p>
                            <h5 class="mb-0">
                              {{
                                productDetails.product_inventory
                                  ? persianTools.digitsEnToFa(
                                      productDetails.product_inventory
                                    )
                                  : persianTools.digitsEnToFa(0)
                              }}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <div class="mt-4 text-muted">
                    <h5 class="fs-14">توضیحات :</h5>
                    <p>
                      {{
                        productDetails.long_description
                          ? extractTextFromFirstParagraph(
                              productDetails.long_description
                            )
                          : ""
                      }}
                    </p>
                  </div>

                  <div class="product-content mt-5">
                    <h5 class="fs-14 mb-3">توضیحات کامل محصول :</h5>
                    <nav>
                      <ul
                        class="nav nav-tabs nav-tabs-custom nav-success"
                        id="nav-tab"
                        role="tablist"
                      >
                        <li class="nav-item">
                          <b-link
                            class="nav-link active"
                            id="nav-speci-tab"
                            data-bs-toggle="tab"
                            href="#nav-speci"
                            role="tab"
                            aria-controls="nav-speci"
                            aria-selected="true"
                            >مشخصات</b-link
                          >
                        </li>
                        <li class="nav-item">
                          <b-link
                            class="nav-link"
                            id="nav-detail-tab"
                            data-bs-toggle="tab"
                            href="#nav-detail"
                            role="tab"
                            aria-controls="nav-detail"
                            aria-selected="false"
                            >جزئیات</b-link
                          >
                        </li>
                      </ul>
                    </nav>
                    <div
                      class="tab-content border border-top-0 p-4"
                      id="nav-tabContent"
                    >
                      <div
                        class="tab-pane fade show active"
                        id="nav-speci"
                        role="tabpanel"
                        aria-labelledby="nav-speci-tab"
                      >
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <tbody>
                              <tr>
                                <th scope="row" style="width: 200px">
                                  دسته بندی
                                </th>
                                <td>{{ productDetails.category_name }}</td>
                              </tr>
                              <tr
                                v-for="value in productDetails.values"
                                :key="value.attribute_id"
                              >
                                <th scope="row">{{ value.attributeName }}</th>
                                <td>{{ value.valueName }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="nav-detail"
                        role="tabpanel"
                        aria-labelledby="nav-detail-tab"
                      >
                        <div>
                          <h5 class="font-size-16 mb-3">
                            {{ productDetails.product_name }}
                          </h5>
                          <div v-html="productDetails.long_description"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-5">
                    <div>
                      <h5 class="fs-14 mb-3">امتیازها و نظرات</h5>
                    </div>
                    <b-row class="gy-4 gx-0">
                      <b-col lg="4">
                        <div>
                          <div class="pb-3">
                            <div class="bg-light px-3 py-2 rounded-2 mb-2">
                              <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                  <div class="fs-16 align-middle text-warning">
                                    <i
                                      v-for="starType in stars"
                                      :key="starType"
                                      :class="starType"
                                    ></i>
                                  </div>
                                </div>
                                <div class="flex-shrink-0">
                                  <h6 class="mb-0">
                                    {{
                                      productDetails.average_rating
                                        ? persianTools.digitsEnToFa(
                                            productDetails.average_rating
                                          )
                                        : persianTools.digitsEnToFa(0)
                                    }}
                                    از ۵
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div class="text-center">
                              <div class="text-muted">
                                از مجموع
                                <span class="fw-medium">{{
                                  productDetails.total_ratings
                                    ? persianTools.digitsEnToFa(
                                        productDetails.total_ratings
                                      )
                                    : persianTools.digitsEnToFa(0)
                                }}</span>
                                امتیاز
                              </div>
                            </div>
                          </div>

                          <div class="mt-3">
                            <div
                              v-for="starData in productDetails.ratings"
                              :key="starData.star"
                            >
                              <b-row class="align-items-center g-2">
                                <div class="col-auto">
                                  <div class="p-2">
                                    <h6 class="mb-0">
                                      {{
                                        persianTools.digitsEnToFa(
                                          parseFloat(starData.star).toFixed(0)
                                        )
                                      }}
                                      ستاره
                                    </h6>
                                  </div>
                                </div>
                                <b-col>
                                  <div class="p-2">
                                    <b-progress
                                      :variant="getVariant(starData.star)"
                                      :class="
                                        getVariantClass(
                                          getVariant(starData.star)
                                        )
                                      "
                                      class="animated-progess progress-sm"
                                      :value="starData.percent"
                                    />
                                  </div>
                                </b-col>
                                <div class="col-auto">
                                  <div class="p-2">
                                    <h6 class="mb-0 text-muted">
                                      {{
                                        persianTools.digitsEnToFa(
                                          starData.count
                                        )
                                      }}
                                    </h6>
                                  </div>
                                </div>
                              </b-row>
                            </div>
                          </div>
                        </div>
                      </b-col>

                      <b-col lg="8">
                        <div class="ps-lg-4">
                          <div class="d-flex flex-wrap align-items-start gap-3">
                            <h5 class="fs-14">نظرات:</h5>
                          </div>

                          <div
                            class="me-lg-n3 pe-lg-4"
                            data-simplebar
                            style="max-height: 225px"
                          >
                            <ul class="list-unstyled mb-0">
                              <li
                                class="py-2"
                                v-for="(
                                  comment, index
                                ) in productDetails.comments"
                                :key="index"
                              >
                                <div class="border border-dashed rounded p-3">
                                  <div class="d-flex align-items-start mb-3">
                                    <div class="hstack gap-3">
                                      <div class="flex-grow-1">
                                        <p class="text-muted mb-0">
                                          {{ comment.commentText }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="d-flex align-items-end">
                                    <div class="flex-grow-1">
                                      <h5 class="fs-14 mb-0">
                                        {{ comment.user }}
                                      </h5>
                                    </div>

                                    <div class="flex-shrink-0">
                                      <p class="text-muted fs-13 mb-0">
                                        {{
                                          comment.created_at
                                            ? toPersianDateTime(
                                                comment.created_at
                                              )
                                            : ""
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.ri-star-half-fill {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>
